import { ContactAddress, ChannelType, FunnelAddress } from 'src/api/generated';

/**
 * Filters contact addresses to get only WhatsApp-compatible phone addresses
 */
export const getWhatsAppAddresses = (
  contactAddresses: ContactAddress[]
): ContactAddress[] => {
  return contactAddresses.filter(
    (address) => address.channelType === ChannelType.PHONE
  );
};

export const getWhatsAppFunnelAddresses = (
  funnelAddresses: FunnelAddress[]
): FunnelAddress[] => {
  return funnelAddresses.filter(
    (address) => address.channelType === ChannelType.WHATSAPP
  );
};

/**
 * Creates dropdown options from WhatsApp addresses
 */
export const createAddressDropdownOptions = (
  whatsappAddresses: ContactAddress[] | FunnelAddress[]
): Array<{ id: number; content: string }> => {
  return whatsappAddresses.map((address) => {
    const content =
      'description' in address && address.description
        ? address.description
        : address.address;

    return {
      id: address.id,
      content,
    };
  });
};
